import React, { useEffect, useState } from "react";
import { Modal, ModalDialog, Button } from "@mui/joy";
import { getFetch } from "../../../../../../fetch/fetch";
import styles from "./callhistory.module.css";
import { formatPhone } from "./callhistoryformat";

const valueLabel : { [v : string] : string } = { student : "학생", parent : "학부모", teacher : "선생님", staff : "직원" };
const kindLabel : { [v : string] : string } = { student : "학생 본인", parent : "학부모", staff : "직원", waiting : "대기자", sms : "문자 연락처", none : "미등록" };

//고객 정보 모달 — CRM 에서 찾을 수 있는 범위(계정·대기자·문자 연락처)만
const ProfileModal : React.FC<any> = (props) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [profile, setProfile] = useState<any>(null);
    const [error, setError] = useState<string>("");

    useEffect(() => {
        if (!props.open || !props.phone) {
            return;
        }
        setProfile(null);
        setError("");
        setLoading(true);
        getFetch(`/dashboard/callcenter/history/contacts/profile?phone=${encodeURIComponent(props.phone)}`)
            .then((result : any) => {
                if (result.message === "success") {
                    setProfile(result.profile);
                } else {
                    setError("고객 정보를 불러오지 못했습니다");
                }
            })
            .catch((e : any) => {
                console.log(e);
                setError("고객 정보를 불러오지 못했습니다");
            })
            .then(() => setLoading(false));
    }, [props.open, props.phone]);

    if (!props.phone) {
        return null;
    }
    const c = profile && profile.contact;

    return (
        <Modal open={props.open} onClose={props.onClose}>
            <ModalDialog>
                <div style={{ width: "440px" }}>
                    <div className={styles.modalTitle}>고객 정보</div>
                    {
                        loading ? <div style={{ color: "#9AA1AB", fontSize: "13px" }}>불러오는 중...</div>
                        : error ? <div className={styles.modalError}>{error}</div>
                        : profile ?
                            <div>
                                <div className={styles.profileRow}><span className={styles.profileKey}>전화번호</span><span>{formatPhone(props.phone)}</span></div>
                                <div className={styles.profileRow}><span className={styles.profileKey}>표시 이름</span><span>{c && c.displayName ? c.displayName : "—"}{c && c.isEnrolled ? <span className={styles.enrolledChip}>재원</span> : ""}</span></div>
                                <div className={styles.profileRow}><span className={styles.profileKey}>매칭 종류</span><span>{kindLabel[(c && c.crmKind) || "none"]}</span></div>
                                <div className={styles.profileRow}><span className={styles.profileKey}>통화</span><span>{c ? `${c.totalCalls}회` : "—"}{c && c.firstContactAt ? ` (첫 접촉 ${c.firstContactAt.slice(0, 10)})` : ""}</span></div>
                                {
                                    profile.users && profile.users.length ?
                                        <div style={{ marginTop: "14px" }}>
                                            <div className={styles.modalLabel}>관련 계정</div>
                                            {
                                                profile.users.map((u : any) => (
                                                    <div key={u.id} className={styles.profileRow}>
                                                        <span className={styles.profileKey}>{valueLabel[u.value] || u.value}</span>
                                                        <span>{u.name}{u.location ? ` · ${u.location}` : ""}{u.value === "student" ? (u.isNow ? " · 재원" : " · 비재원") : ""}{u.firstCome ? ` · 입실 ${u.firstCome}` : ""}</span>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        : ""
                                }
                                {
                                    profile.waiting && profile.waiting.length ?
                                        <div style={{ marginTop: "14px" }}>
                                            <div className={styles.modalLabel}>대기자 등록</div>
                                            {
                                                profile.waiting.map((w : any) => (
                                                    <div key={w.id} className={styles.profileRow}>
                                                        <span className={styles.profileKey}>{w.createdAt}</span>
                                                        <span>{w.name}{w.location ? ` · ${w.location}` : ""}</span>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        : ""
                                }
                                {
                                    profile.smsContact ?
                                        <div style={{ marginTop: "14px" }}>
                                            <div className={styles.modalLabel}>문자 연락처</div>
                                            <div className={styles.profileRow}>
                                                <span className={styles.profileKey}>{profile.smsContact.name || "—"}</span>
                                                <span>{profile.smsContact.description || ""}{profile.smsContact.blocked ? " · 차단됨" : ""}</span>
                                            </div>
                                        </div>
                                        : ""
                                }
                                {
                                    (!profile.users || !profile.users.length) && (!profile.waiting || !profile.waiting.length) && !profile.smsContact ?
                                        <div style={{ color: "#9AA1AB", fontSize: "13px", marginTop: "14px" }}>CRM 에 등록된 정보가 없습니다</div>
                                        : ""
                                }
                            </div>
                            : ""
                    }
                    <div className={styles.modalButtons}>
                        <Button variant="plain" color="neutral" onClick={props.onClose}>닫기</Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default ProfileModal;
